module.exports = __webpack_public_path__ + "img/sending_5.09570d5f.png";